<template>
    <div
        v-if="computedAgencies.length > 0"
        class="profile-agency">
        <div class="profile-agency__title">
            <h3>Мои агентства недвижимости</h3>
        </div>

        <ul class="profile-agency__list">
            <li
                v-for="agency in computedAgencies"
                :key="agency.agencyId"
                class="profile-agency__list-item">
                {{ agency.agencyName }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name : 'ProfileAgency',
    props: {
        agencies: {
            type    : Array,
            required: true
        }
    },

    computed: {
        computedAgencies() {
            return this.agencies.filter((agency) => agency.agencyName?.length > 0);
        }
    }
};
</script>

<style lang="scss">
@import "ProfileAgency";
</style>